"use client";

import { createAbsoluteUrl } from "@/service/url";
import { createPath } from "@/service/routing/routing";
import { ArticleStructuredData } from "@/components/common/structured-data/article-structured-data";

export const StructuredData = ({
  article,
  access,
}: {
  article: ArticleVM;
  access: ResourceAccess;
}) => {
  return (
    <ArticleStructuredData
      article={article}
      headline={article.title}
      url={createAbsoluteUrl(
        createPath("vademecum.show", {
          slug: article.slug,
          categorySlug: article.category.slug,
        }),
      )}
      isFree={access.granted}
      type="Article"
    />
  );
};
